// @flow

import React from 'react';
import PriceTitle from '../priceTitle';
import { PriceWrapper, StyledPrice as Price } from './price.styled';

type Props = {
  amount: number,
};

export default ({ amount }: Props) => (
  <PriceWrapper>
    <PriceTitle />
    <Price amount={amount} />
  </PriceWrapper>
);
